import restConfigService from '@/services/rest-api-config';

import {
  MarkAsAlreadyHadAppointmentApi,
  MarkAsAlreadyHadAppointmentPostRequest,
} from 'rpc/apis/MarkAsAlreadyHadAppointmentApi';

import { HasAccountAtMepApi, HasAccountAtMepPostRequest } from 'rpc/apis/HasAccountAtMepApi';
import { CreateEmployeeApi, CreateEmployeePostRequest } from 'rpc/apis/CreateEmployeeApi';
import { CampaignsApi } from 'rpc/apis/CampaignsApi';
import { JobManagersApi, JobManagersPostRequest } from 'rpc/apis/JobManagersApi';
import {
  AppointmentHasBeenBookedByEmployeeApi,
  AppointmentHasBeenBookedByEmployeePostRequest,
} from 'rpc/apis/AppointmentHasBeenBookedByEmployeeApi';

import type { HasAccountAtMepResponse } from 'rpc/models/HasAccountAtMepResponse';
import { CreateEmployeeResponse } from 'rpc/models/CreateEmployeeResponse';
import { Campaign, JobManager } from 'rpc/models';

export type {
  HasAccountAtMepResponse,
  CreateEmployeeResponse,
  Campaign,
  JobManager,
};

export default {
  async hasAccountAtMep(emailAddress: string): Promise<HasAccountAtMepResponse> {
    const config = restConfigService.getBaseConfig();
    const hasAccountAtMepPost: HasAccountAtMepApi = new HasAccountAtMepApi(config);

    const request: HasAccountAtMepPostRequest = {
      hasAccountAtMepRequest: {
        emailAddress,
      },
    };

    return hasAccountAtMepPost.hasAccountAtMepPost(request);
  },

  async createEmployee(fullName: string, emailAddress: string,
    countryCode: string, localPhoneNumber: string,
    age: number, zipCode: string, placeOfResidence: string, campaignCode: string):
    Promise<CreateEmployeeResponse> {
    const config = restConfigService.getBaseConfig();
    const createEmployeePost: CreateEmployeeApi = new CreateEmployeeApi(config);

    const request: CreateEmployeePostRequest = {
      createEmployeeRequest: {
        fullName,
        emailAddress,
        countryCode,
        localPhoneNumber,
        age,
        zipCode,
        placeOfResidence,
        campaignCode,
      },
    };

    const promise = createEmployeePost.createEmployeePost(request);
    return promise.then((response: CreateEmployeeResponse) => response);
  },

  async getCampaigns(): Promise<Campaign[]> {
    const config = restConfigService.getBaseConfig();
    const campaignsApi = new CampaignsApi(config);

    return campaignsApi.campaignsGet();
  },

  async getJobManagers(contactsFunction: string): Promise<JobManager[]> {
    const config = restConfigService.getBaseConfig();
    const jobManagersPost: JobManagersApi = new JobManagersApi(config);

    const request: JobManagersPostRequest = {
      jobManagersRequest: {
        contactsFunction,
      },
    };

    return jobManagersPost.jobManagersPost(request);
  },

  async markAsAlreadyHadAppointment(
    fullName: string,
    contactsFunction: string,
    emailAddress: string,
  ): Promise<void> {
    const config = restConfigService.getBaseConfig();
    const markAsAlreadyHadAppointmentPost:
      MarkAsAlreadyHadAppointmentApi = new MarkAsAlreadyHadAppointmentApi(config);

    const request: MarkAsAlreadyHadAppointmentPostRequest = {
      markAsAlreadyHadAppointmentRequest: {
        fullName,
        contactsFunction,
        emailAddress,
      },
    };

    await markAsAlreadyHadAppointmentPost.markAsAlreadyHadAppointmentPost(request);
  },

  async confirmAppointmentHasBeenBooked(emailAddress: string): Promise<void> {
    const config = restConfigService.getBaseConfig();

    const request: AppointmentHasBeenBookedByEmployeePostRequest = {
      appointmentHasBeenBookedByEmployeeRequest: {
        emailAddress,
      },
    };

    const appointmentHasBeenBookedByEmployeeApi = new AppointmentHasBeenBookedByEmployeeApi(config);

    await appointmentHasBeenBookedByEmployeeApi.appointmentHasBeenBookedByEmployeePost(request);
  },
};
